import type { AntDesignTabItem, TabViewItem } from "./tab-view.type";

import classNames from "classnames";

export const computeTabItems = (tabs: TabViewItem[]): AntDesignTabItem[] => {
  return (tabs ?? [])
    .filter((tab) => !tab.hidden)
    .map((tab): AntDesignTabItem => {
      if (!tab.fullHeight) return tab;
      return {
        ...tab,
        className: classNames(tab.className, "-full-height"),
      };
    });
};
